import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink, useHistory } from 'react-router-dom';

import ConfigIcon from "../../assets/icons/config.svg";
import shareIcon from "../../assets/icons/share.svg";
import openInNewIcon from "../../assets/icons/open-in-new.svg";
import logoutIcon from "../../assets/icons/logout.svg";
import editIcon from '../../assets/icons/edit.svg'
import categoriesIcon from '../../assets/icons/collections.svg'
import CouponIcon from '../../assets/icons/coupon.svg'
import FreemiumCouponNavBadge from '../FreemiumCouponNavBadge/FreemiumCouponNavBadge';
import BetaNavBadge from '../BetaNavBadge/BetaNavBadge';
import { isPromotionsFeatureEnabled, isCouponsFeatureEnabled } from '../../constants/promotionConfig';
import { makeStyles } from '@material-ui/core/styles';

import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { routes } from '../../constants.js/misc';

const useStyles = makeStyles({
    listItem: {
        borderBottom: 'solid #ECECF2 1px',
    },
    ecometriPlusItem: {
        position: 'relative',
        borderBottom: 'solid #ECECF2 1px',
        '& .MuiListItemIcon-root, & .MuiListItemText-root': {
            position: 'relative',
            zIndex: 1,
        },
        '& .MuiListItemIcon-root img': {
            width: 24,
            height: 24,
            display: 'block',
        },
        '&::before': {
            content: '""',
            position: 'absolute',
            left: 16,
            right: 16,
            top: 4,
            bottom: 4,
            borderRadius: 10,
            backgroundColor: 'rgba(158, 232, 112, 0.12)',
            border: '1px solid rgba(158, 232, 112, 0.55)',
            pointerEvents: 'none',
        },
    },
    ecometriPlusLabel: {
        fontWeight: 600,
        color: '#173300',
    },
    ecometriPlusBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: 6,
        padding: '1px 5px',
        borderRadius: 4,
        fontSize: 9,
        fontWeight: 700,
        letterSpacing: '0.05em',
        lineHeight: 1.3,
        backgroundColor: 'rgba(158, 232, 112, 0.25)',
        color: '#9EE870',
    },
});

const MobileDrawer = ({ open, onClose, storeData, logOut, dataStore }) => {
    const { t } = useTranslation();
    const history = useHistory();
    const classes = useStyles();

    const handleLogout = () => {
        logOut();
        history.replace(routes.homeUrl);
    };

    const promotionsFeatureEnabled = isPromotionsFeatureEnabled(storeData);
    const couponsFeatureEnabled = isCouponsFeatureEnabled(storeData);

    const storeUrl = `https://${dataStore.domain ? dataStore.domain : (`${dataStore.url}.ecometri.shop`)}/${dataStore?.default_user_store ? dataStore?.default_user_store?.mobile_phone_number : 0}`;

    const shareStore = () => {
        const shareData = {
            title: storeData.name,
            text: storeData.description.replace( /(<([^>]+)>)/ig, ''),
            url: storeUrl
        }
        if (navigator.canShare) {
            navigator.share(shareData)
                .then(() => console.log('Share was successful.'))
                .catch((error) => console.log('Sharing failed', error));
          } else {
            console.log(`Your system doesn't support sharing`);
          }
    }
    return (
        <Drawer
            anchor="bottom"
            open={open}
            onClose={onClose}
            PaperProps={{ style : { borderRadius: '16px 16px 0px 0px' } }}>
            <div
                role="presentation"
                onClick={onClose}
                onKeyDown={onClose}>
                <List style={{ paddingBottom: 0 }}>
                    <ListItem
                        className={classes.listItem}
                        component={Link}
                        href={storeUrl}
                        color="inherit"
                        target="_blank"
                        button
                        key={t('MobileDrawer.store')}>
                        <ListItemIcon>
                            <img src={openInNewIcon} alt={t('MobileDrawer.store')} />
                        </ListItemIcon>
                        <ListItemText primary={t('MobileDrawer.store')} />
                    </ListItem>
                    <ListItem
                        className={classes.listItem}
                        onClick={shareStore}
                        button
                        key={t('MobileDrawer.share')}>
                        <ListItemIcon>
                            <img src={shareIcon} alt={t('MobileDrawer.share')} />
                        </ListItemIcon>
                        <ListItemText primary={t('MobileDrawer.share')} />
                    </ListItem>
                    <ListItem
                        className={classes.listItem}
                        component={RouterLink}
                        to={routes.config}
                        button
                        key={t('MobileDrawer.config')}>
                        <ListItemIcon>
                            <img src={ConfigIcon} alt={t('MobileDrawer.config')} />
                        </ListItemIcon>
                        <ListItemText primary={t('MobileDrawer.config')} />
                    </ListItem>
                    <ListItem
                        className={classes.listItem}
                        component={RouterLink}
                        to={routes.store}
                        button
                        key={t('MobileDrawer.edit')}>
                        <ListItemIcon>
                            <img src={editIcon} alt={t('MobileDrawer.edit')} />
                        </ListItemIcon>
                        <ListItemText primary={t('MobileDrawer.edit')} />
                    </ListItem>
                    <ListItem
                        className={classes.listItem}
                        component={RouterLink}
                        to={routes.couponsPage}
                        button
                        key={t('CouponsTitle')}>
                        <ListItemIcon>
                            <Box style={{ position: 'relative', display: 'inline-flex' }}>
                                <img src={CouponIcon} alt={t('CouponsTitle')} />
                                {!couponsFeatureEnabled && (
                                    <FreemiumCouponNavBadge style={{ top: -10, right: -5 }} />
                                )}
                            </Box>
                        </ListItemIcon>
                        <ListItemText primary={t('CouponsTitle')} />
                    </ListItem>
                    <ListItem
                        className={classes.listItem}
                        component={RouterLink}
                        to={routes.promotionsPage}
                        button
                        key={t('PromotionsTitle')}>
                        <ListItemIcon>
                            <Box style={{ position: 'relative', display: 'inline-flex' }}>
                                <img src={CouponIcon} alt={t('PromotionsTitle')} />
                                {promotionsFeatureEnabled ? (
                                    <BetaNavBadge style={{ top: -7, right: -12 }} />
                                ) : (
                                    <FreemiumCouponNavBadge style={{ top: -10, right: -5 }} />
                                )}
                            </Box>
                        </ListItemIcon>
                        <ListItemText primary={t('PromotionsTitle')} />
                    </ListItem>
                    <ListItem
                        className={classes.listItem}
                        component={RouterLink}
                        to={routes.mobileManageCategories}
                        button
                        key={t('MobileDrawer.categories')}>
                        <ListItemIcon>
                            <img src={categoriesIcon} alt={t('MobileDrawer.categories')} />
                        </ListItemIcon>
                        <ListItemText primary={t('MobileDrawer.categories')} />
                    </ListItem>
                    <ListItem
                        className={classes.ecometriPlusItem}
                        component={RouterLink}
                        to={routes.ecometriPlusPage}
                        button
                        key={t('Menu.ecometriPlus')}>
                        <ListItemIcon>
                            <img src={openInNewIcon} alt={t('Menu.ecometriPlus')} />
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                <>
                                    <span className={classes.ecometriPlusLabel}>
                                        {t('Menu.ecometriPlus')}
                                    </span>
                                    <span className={classes.ecometriPlusBadge}>PLUS</span>
                                </>
                            }
                        />
                    </ListItem>
                    <ListItem
                        className={classes.listItem}
                        style={{ color: '#CB7C7A' }}
                        onClick={handleLogout}
                        button
                        key={t('MobileDrawer.logout')}>
                        <ListItemIcon>
                            <img src={logoutIcon} alt={t('MobileDrawer.logout')} />
                        </ListItemIcon>
                        <ListItemText primary={t('MobileDrawer.logout')} />
                    </ListItem>
                </List>
            </div>
        </Drawer>
    );
};

const mapStateToProps = ({ common }) => ({
    storeData: common.storeData
});

export default connect(
    mapStateToProps
)(MobileDrawer);
